import React, { FC } from "react"
import "./AssistantLibrary.scss"
import bombeirosIcon from "Static/images/bombeirosicon.jpeg"
import planoDiretorGoianiaIcon from "Static/images/plano-diretor-goiania.jpg"
import abnt from "Static/images/abnt.jpg"

interface AssistantLibraryProps {
  onSelectAssistant?: (assistant: string) => void;
}

export const AssistantLibrary: FC<AssistantLibraryProps> = ({ onSelectAssistant }) => {
  return (
    <div className="assistant-library-view">
      <div className="library-header">
        <h1>Biblioteca de Assistentes</h1>
        <p>Escolha um assistente especializado para responder sobre normas, leis e processos da construção civil.</p>
      </div>

      <div className="library-content">

        <div className="library-search">
          <div className="search-input-wrapper">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path d="M21 21l-4.35-4.35" stroke="#8697A8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <circle cx="11" cy="11" r="6" stroke="#8697A8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <input
              type="text"
              placeholder="Busque um assistente..."
              className="library-search-input"
            />
          </div>
        </div>

        <div className="library-categories">
          <button className="category-tab active">Todos</button>
          <button className="category-tab">Normas ABNT</button>
          <button className="category-tab">BIM & Compatibilização</button>
          <button className="category-tab">Orçamentação & Custos</button>
        </div>

        <div className="assistants-grid">
          <div className="assistant-card" style={{ cursor: 'pointer' }} onClick={() => onSelectAssistant?.('Bombeiros')}>
            <div className="assistant-icon bombeiros-bg">
              <img src={bombeirosIcon} alt="CBM-GO" />
            </div>
            <div className="assistant-info">
              <h3>CBM-GO, Corpo de Bombeiros Militar de Goiás</h3>
              <p>Fornece orientações e instruções técnicas de prevenção e combate a incêndios exigidas pelo Corpo de Bombeiros de Goiás.</p>
            </div>
            <span className="by-coordly">por Coordly</span>
          </div>

          <div className="assistant-card">
            <div className="assistant-icon">
              <img src={abnt} alt="ABNT NBR 15575 - Norma de Desempenho" />
            </div>
            <div className="assistant-info">
              <h3>ABNT NBR 15575 - Norma de Desempenho</h3>
              <p>Explica os requisitos de desempenho em edificações habitacionais, como acústica, térmica, durabilidade e segurança.</p>
            </div>
            <span className="by-coordly">por Coordly</span>
          </div>

          <div className="assistant-card">
            <div className="assistant-icon">
              <img src={planoDiretorGoianiaIcon} alt="Plano Diretor de Goiânia" />
            </div>
            <div className="assistant-info">
              <h3>Plano Diretor de Goiânia</h3>
              <p>Ajuda a verificar diretrizes urbanísticas, zoneamento e regras de ocupação do solo estabelecidas pelo Plano Diretor de Goiânia.</p>
            </div>
            <span className="by-coordly">por Coordly</span>
          </div>

          <div className="assistant-card">
            <div className="assistant-icon">
              <img src={abnt} alt="ABNT" />
            </div>
            <div className="assistant-info">
              <h3>Normas de Edificações ABNT</h3>
              <p>Reúne normas gerais da ABNT aplicáveis a projetos, execução e manutenção de edificações no Brasil.</p>
            </div>
            <span className="by-coordly">por Coordly</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssistantLibrary
